import {useFragment} from "react-relay";
import {UserNameColumnProps} from "./user-name-column.types";
import {USER_NAME_FRAGMENT} from "./user.name.column.graphql";
import {userNameColumn_Fragment$key} from "../../../../__generated__/userNameColumn_Fragment.graphql";

export const UserNameColumn = ({ userFragmentRef }: UserNameColumnProps) => {
    const user = useFragment<userNameColumn_Fragment$key>(USER_NAME_FRAGMENT, userFragmentRef);

    return (
        <div>
            {user.extension?.lastName} {user.extension?.firstName}
        </div>
    );
};
